<div class="flex flex-col gap-5 w-full">

  <!-- Cabeçalho -->
  <div class="bg-white dark:bg-black rounded-xl shadow-sm border border-gray-200 dark:border-zinc-800 px-6 py-4">
    <div class="flex items-center gap-3">
      <div class="w-10 h-10 rounded-full bg-red-50 dark:bg-red-950/40 flex items-center justify-center flex-shrink-0">
        <i class="pi pi-shield text-xl text-[#E41B2E]"></i>
      </div>
      <div>
        <h1 class="text-xl font-bold text-gray-800 dark:text-white leading-tight">Administração</h1>
        <p class="text-sm text-gray-500 dark:text-gray-400">Painel de controle do sistema</p>
      </div>
    </div>
  </div>

  <!-- Stats -->
  <div class="grid grid-cols-2 lg:grid-cols-4 gap-3">
    <div class="bg-white dark:bg-black rounded-xl border border-gray-200 dark:border-zinc-800 px-4 py-3 flex flex-col gap-1">
      <span class="text-xs text-gray-500 dark:text-gray-400 uppercase tracking-wide font-medium">Total</span>
      @if (loading) { <p-skeleton height="1.75rem" width="3rem"/> }
      @else { <span class="text-2xl font-bold text-gray-800 dark:text-white">{{ stats.totalUsuarios }}</span> }
      <span class="text-xs text-gray-400">usuários</span>
    </div>
    <div class="bg-white dark:bg-black rounded-xl border border-gray-200 dark:border-zinc-800 px-4 py-3 flex flex-col gap-1">
      <span class="text-xs text-yellow-600 dark:text-yellow-500 uppercase tracking-wide font-medium">Pendentes</span>
      @if (loading) { <p-skeleton height="1.75rem" width="3rem"/> }
      @else { <span class="text-2xl font-bold text-yellow-600 dark:text-yellow-500">{{ stats.pendentes }}</span> }
      <span class="text-xs text-gray-400">aguardando</span>
    </div>
    <div class="bg-white dark:bg-black rounded-xl border border-gray-200 dark:border-zinc-800 px-4 py-3 flex flex-col gap-1">
      <span class="text-xs text-green-600 dark:text-green-400 uppercase tracking-wide font-medium">Aprovados</span>
      @if (loading) { <p-skeleton height="1.75rem" width="3rem"/> }
      @else { <span class="text-2xl font-bold text-green-600 dark:text-green-400">{{ stats.aprovados }}</span> }
      <span class="text-xs text-gray-400">com acesso</span>
    </div>
    <div class="bg-white dark:bg-black rounded-xl border border-gray-200 dark:border-zinc-800 px-4 py-3 flex flex-col gap-1">
      <span class="text-xs text-red-500 dark:text-red-400 uppercase tracking-wide font-medium">Recusados</span>
      @if (loading) { <p-skeleton height="1.75rem" width="3rem"/> }
      @else { <span class="text-2xl font-bold text-red-500 dark:text-red-400">{{ stats.recusados }}</span> }
      <span class="text-xs text-gray-400">sem acesso</span>
    </div>
  </div>

  <!-- Título seção -->
  <p class="text-xs font-semibold text-gray-400 dark:text-zinc-500 uppercase tracking-widest -mb-2">Gerenciamento</p>

  <!-- Cards de ação -->
  <div class="grid grid-cols-1 md:grid-cols-3 gap-4">

    <!-- Usuários -->
    <div (click)="navegarUsuarios()"
         class="group bg-white dark:bg-black rounded-xl border border-gray-200 dark:border-zinc-800
                hover:border-[#E41B2E] dark:hover:border-red-700 hover:shadow-md
                transition-all cursor-pointer p-5 flex flex-col gap-3">
      <div class="flex items-center gap-3">
        <div class="w-9 h-9 rounded-lg bg-red-50 dark:bg-red-950/40 flex items-center justify-center
                    group-hover:bg-[#E41B2E] transition-colors">
          <i class="pi pi-users text-[#E41B2E] group-hover:text-white transition-colors"></i>
        </div>
        <span class="font-semibold text-gray-800 dark:text-white">Usuários</span>
        @if (stats.pendentes > 0) {
          <span class="ml-auto inline-flex items-center justify-center w-5 h-5 rounded-full bg-yellow-500 text-white text-[10px] font-bold">
            {{ stats.pendentes }}
          </span>
        }
      </div>
      <p class="text-sm text-gray-500 dark:text-gray-400 leading-relaxed">
        Gerencie usuários, aprove solicitações de acesso e defina perfis de permissão.
      </p>
      <span class="text-xs text-[#E41B2E] font-medium flex items-center gap-1 mt-auto">
        Acessar <i class="pi pi-arrow-right text-[10px]"></i>
      </span>
    </div>

    <!-- Gerenciar Listas -->
    <div (click)="navegarListas()"
         class="group bg-white dark:bg-black rounded-xl border border-gray-200 dark:border-zinc-800
                hover:border-[#E41B2E] dark:hover:border-red-700 hover:shadow-md
                transition-all cursor-pointer p-5 flex flex-col gap-3">
      <div class="flex items-center gap-3">
        <div class="w-9 h-9 rounded-lg bg-red-50 dark:bg-red-950/40 flex items-center justify-center
                    group-hover:bg-[#E41B2E] transition-colors">
          <i class="pi pi-list text-[#E41B2E] group-hover:text-white transition-colors"></i>
        </div>
        <span class="font-semibold text-gray-800 dark:text-white">Listas</span>
      </div>
      <p class="text-sm text-gray-500 dark:text-gray-400 leading-relaxed">
        Adicione ou remova valores das listas suspensas: Fases, Status, Motivos, Concessionárias e mais.
      </p>
      <span class="text-xs text-[#E41B2E] font-medium flex items-center gap-1 mt-auto">
        Acessar <i class="pi pi-arrow-right text-[10px]"></i>
      </span>
    </div>

    <!-- Metas de Bonificação -->
    <div (click)="navegarMetas()"
         class="group bg-white dark:bg-black rounded-xl border border-gray-200 dark:border-zinc-800
                hover:border-[#E41B2E] dark:hover:border-red-700 hover:shadow-md
                transition-all cursor-pointer p-5 flex flex-col gap-3">
      <div class="flex items-center gap-3">
        <div class="w-9 h-9 rounded-lg bg-red-50 dark:bg-red-950/40 flex items-center justify-center
                    group-hover:bg-[#E41B2E] transition-colors">
          <i class="pi pi-chart-bar text-[#E41B2E] group-hover:text-white transition-colors"></i>
        </div>
        <span class="font-semibold text-gray-800 dark:text-white">Metas de Bonificação</span>
      </div>
      <p class="text-sm text-gray-500 dark:text-gray-400 leading-relaxed">
        Configure metas, defina valores, períodos e quais status de notificação contribuem para o atingimento.
      </p>
      <span class="text-xs text-[#E41B2E] font-medium flex items-center gap-1 mt-auto">
        Acessar <i class="pi pi-arrow-right text-[10px]"></i>
      </span>
    </div>

    <!-- Perfis de Acesso (informativo) -->
    <div class="bg-white dark:bg-black rounded-xl border border-gray-200 dark:border-zinc-800 p-5 flex flex-col gap-3">
      <div class="flex items-center gap-3">
        <div class="w-9 h-9 rounded-lg bg-gray-100 dark:bg-zinc-800 flex items-center justify-center">
          <i class="pi pi-id-card text-gray-500 dark:text-gray-400"></i>
        </div>
        <span class="font-semibold text-gray-800 dark:text-white">Perfis de Acesso</span>
      </div>
      <div class="space-y-2 text-sm text-gray-600 dark:text-gray-300">
        <div class="flex items-center gap-2">
          <span class="w-2 h-2 rounded-full bg-[#E41B2E] flex-shrink-0"></span>
          <span><strong>Administrador</strong> — acesso total + painel admin</span>
        </div>
        <div class="flex items-center gap-2">
          <span class="w-2 h-2 rounded-full bg-blue-400 flex-shrink-0"></span>
          <span><strong>Usuário Avançado</strong> — criar, editar, exportar</span>
        </div>
        <div class="flex items-center gap-2">
          <span class="w-2 h-2 rounded-full bg-gray-300 dark:bg-gray-600 flex-shrink-0"></span>
          <span><strong>Visualizador</strong> — apenas consulta</span>
        </div>
      </div>
      <p class="text-xs text-gray-400 dark:text-zinc-500 mt-auto">Perfis são atribuídos em Usuários</p>
    </div>

  </div>
</div>
